/**
 * The HQ console's own namespace, `hq` (spec/14).
 *
 * A separate entry point, like `@clavian/i18n/console`: only the console's HQ build loads it, so the
 * venue and organisation console carries no HQ copy at all (the two are separate builds on separate
 * origins, spec/14). The HQ build passes it to `createI18n` beside the console's namespace, whose
 * sign-in, second factor and settings renderer it shares:
 *
 *   createI18n({ language, extraResources: mergedWith(consoleResources, hqResources), use: [initReactI18next] });
 */
import hqEn from './locales/en/hq.js';
export const hqNamespace = 'hq';
export const hqResources = {
    en: { hq: hqEn },
};
//# sourceMappingURL=hq.js.map